module.exports = __webpack_public_path__ + "static/media/ALI.4b899044.svg";